import { Form, useFormikContext } from 'formik';
import { Button } from 'yoso';
import { T } from '~/components/I18n';
import { useLevelUpRequirement } from '~/components/Level/Level.hooks';
import { LevelUpDonCardField } from '~/components/LevelUp/Card/Don/LevelUpDonCardField';
import { LevelUpPurchasedCardField } from '~/components/LevelUp/Card/Purchased/LevelUpPurchasedCardField';
import { LevelUpRequirementList } from '~/components/LevelUp/Card/Requirement/LevelUpRequirementList';
import { LevelUpSelectCard } from '~/components/LevelUp/Card/Select/LevelUpSelectCard';
import { LevelUpFormHero } from '~/components/LevelUp/Form/Hero/LevelUpFormHero';
import { LevelUpValues } from '~/components/LevelUp/LevelUp';
import { StickyBottom } from '~/components/Sticky/StickyBottom';

export const LevelUpForm = () => {
  const { isValid, isSubmitting, values } = useFormikContext<LevelUpValues>();
  const { level } = values;
  const {
    data: {
      balance: { minAmount: requiredDon },
      purchase: { minAmount: requiredPurchase },
    },
  } = useLevelUpRequirement(level);

  return (
    <Form className="level-up">
      <div className="level-up-header">
        <LevelUpFormHero />
      </div>
      <div className="level-up-body">
        <LevelUpSelectCard />
        <LevelUpDonCardField max={requiredDon} />
        {requiredPurchase > 0 && <LevelUpPurchasedCardField max={requiredPurchase} />}
      </div>
      <StickyBottom className="level-up-footer">
        <LevelUpRequirementList className="level-up-footer-list" />
        <Button
          className="level-up-button"
          type="submit"
          color="primary"
          size="large"
          block
          disabled={!isValid || isSubmitting}
          data-event="click"
          data-event-target="levelup_btn">
          <T name="citizen_membership_levelup_page_title" />
        </Button>
      </StickyBottom>
    </Form>
  );
};
